// mutations of the state happens here
import types from './mutation-types'

export default {
  [types.FETCH_POLICIES_PENDING](state) {
    // leaving this for when policies are listed
    state.policiesLoaded = false
  },
  [types.FETCH_POLICIES_SUCCESS](state) {
    // leaving this for when policies are listed
    state.policiesLoaded = true
  },
  [types.FETCH_POLICIES_FAILURE](state) {
    // leaving this for when policies are listed
  },
  [types.LOAD_POLICIES](state, policies) {
    state.policyList = policies
  },
  [types.SET_POLICY_TYPE](state, policyType) {
    state.policyType = policyType
  },
}
